import { recipe } from "@vanilla-extract/recipes";
import { style } from "@vanilla-extract/css";

import { theme } from "../../theme/css/theme.css";
import { transition } from "../../utils/transition";
import { disabledState } from "../../theme/disabledState";

export const containerStyle = recipe({
  base: {
    display: "inline-flex",
    alignItems: "center",
    position: "relative",
    borderRadius: "999px",
    overflow: "hidden",
    flexShrink: 0,
    flexGrow: 0,
    transition: transition("background-color", "outline", "opacity"),
    borderColor: "transparent",
  },
  variants: {
    variant: {
      primary: {
        vars: {
          "--unchecked-background-color": theme.colors.inputPanel,
          "--unchecked-background-color__hover": theme.colors.primary,
          "--checked-background-color": theme.colors.primary,
          "--checked-background-color__hover": theme.colors.primaryHover,
        },
      },
      secondary: {
        vars: {
          "--unchecked-background-color": theme.colors.inputPanel,
          "--unchecked-background-color__hover": theme.colors.success,
          "--checked-background-color": theme.colors.success,
          "--checked-background-color__hover": theme.colors.successHover,
        },
      },
    },
    checked: {
      true: {
        backgroundColor: "var(--checked-background-color)",
        ":hover": {
          backgroundColor: "var(--checked-background-color__hover)",
        },
        ":before": {
          opacity: 0,
        },
      },
      false: {
        backgroundColor: "var(--unchecked-background-color)",
        ":hover": {
          backgroundColor: "var(--unchecked-background-color__hover)",
        },
      },
    },
    disabled: {
      true: {
        ...disabledState,
        pointerEvents: "none",
      },
      false: {
        cursor: "pointer",
      },
    },
    size: {
      s: {
        height: theme.spacings.m,
        width: theme.spacings.xl,
      },
      m: {
        height: theme.spacings.l,
        width: theme.spacings.xxl,
      },
    },
  },
  defaultVariants: {
    size: "m",
    checked: false,
    disabled: false,
  },
});

export const checkboxStyle = style({
  opacity: 0,
  position: "absolute",
  width: "100%",
  height: "100%",
  margin: 0,
  selectors: {
    "&:not([disabled])": {
      cursor: "pointer",
    },
  },
});

export const knobStyle = recipe({
  base: {
    content: '""',
    position: "absolute",
    borderRadius: "50%",
    transition: transition("transform"),
    backgroundColor: "var(--unchecked-background-color)",
  },
  variants: {
    variant: {
      primary: {
        vars: {
          "--unchecked-background-color": theme.colors.background,
          "--checked-background-color": theme.colors.background,
        },
      },
      secondary: {
        vars: {
          "--unchecked-background-color": theme.colors.background,
          "--checked-background-color": theme.colors.background,
        },
      },
    },
    checked: {
      true: {
        transform: `translateX(var(--width))`,
        backgroundColor: "var(--checked-background-color)",
      },
    },
    size: {
      s: {
        width: `calc(${theme.spacings.m} - ${theme.spacings.xs})`,
        height: `calc(${theme.spacings.m} - ${theme.spacings.xs})`,
        left: `calc(${theme.spacings.xs} / 2)`,
        bottom: `calc(${theme.spacings.xs} / 2)`,
        "--width": theme.spacings.m,
      },
      m: {
        width: `calc(${theme.spacings.l} - ${theme.spacings.xs})`,
        height: `calc(${theme.spacings.l} - ${theme.spacings.xs})`,
        left: `calc(${theme.spacings.xs} / 2)`,
        bottom: `calc(${theme.spacings.xs} / 2)`,
        "--width": theme.spacings.l,
      },
    },
  },
  defaultVariants: {
    size: "m",
  },
});
